<script>
import CartPanel from '@phoenix/mixins/components/checkout/summary/CartPanel';
import laravelRoute from 'ziggyRoute';
import Panel from '../../common/Panel';
import CartContent from './CartContent';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  components: {
    CartContent,
    Panel,
  },

  mixins: [CartPanel],

  data() {
    return {
      checkoutUrl: laravelRoute('checkout_page'),
    };
  },

  computed: {
    ...mapState('cartPreview', ['loading', 'cart']),

    ...mapGetters('cartPreview', ['hasItems', 'cartTotal', 'cartItems']),
  },

  mounted() {
    // We call this now as we don't have the sign-in form yet in the menu,
    // Once we have it, the call will be done in loadCustomerInfo in currentUser.
    this.refreshWishlistFromCookie();
  },

  methods: {
    ...mapActions('wishlist', ['refreshWishlistFromCookie']),
  },
};
</script>

<template>
  <panel id="cart-panel" reverse :title="$t('Checkout.cartTitle')" :options="panelOptions">
    <template #content>
      <template v-if="hasItems">
        <CartContent :cart-items="cartItems" data-cy="cart-summary-content" />

        <hr class="mt-base" />

        <div class="flex mt-base">
          <div class="uppercase">{{ $t('Checkout.total') }}</div>
          <div class="flex-grow text-end">
            <div class="product-price product-price--small">
              <span class="product-price__value">{{ cartTotal }}</span>
              <span class="product-price__vat">{{ cart.vatInfo }}</span>
            </div>
          </div>
        </div>

        <hr class="mt-base" />

        <div class="btn-grid mt-base">
          <a :href="checkoutUrl" class="btn btn--default btn--full btn--negative" data-cy="proceed-to-checkout-btn">
            <span class="btn__text">{{ $t('Checkout.proceedToCheckout') }}</span>
          </a>

          <button type="button" class="btn btn--default btn--full" data-panel-close="cart-panel">
            <span class="btn__text pointer-events-none">{{ $t('Checkout.continueShopping') }}</span>
          </button>
        </div>
      </template>
      <template v-else>
        <div class="uppercase">
          {{ $t('Checkout.emptyShoppingBagTitle') }}
        </div>

        <hr class="my-base" />

        <div class="btn-grid">
          <button type="button" class="btn btn--default btn--full btn--negative" data-panel-close="cart-panel">
            <span class="btn__text pointer-events-none">{{ $t('Checkout.continueShopping') }}</span>
          </button>
        </div>
      </template>

      <div v-if="loading" class="loader-overlay loader-overlay--light">
        <div class="loader loader--dark loader--lg">
          <div class="loader__inner"></div>
        </div>
      </div>
    </template>
  </panel>
</template>
